import { PromotionCategoryType } from "@comparaonline/offers-models-constants";
import { Coupon, PaymentMethod } from "@comparaonline/cicl-funnel-schema";
import { getConfig } from "../../../../config/app";
import { ENTITY_CODE_FREE_INSTALLMENT_RIBBON } from "../../constants";
import { Offer } from "@comparaonline/offers-models";

const URL = getConfig("couponService.byCode");

const createGiftPA = (label: string, coupon: Coupon) => ({
  enabled: true,
  entity: {
    code: coupon.category.code,
    dataType: "string",
    icon: "gift",
    label
  },
  featured: true,
  value: coupon.description
});

const getFlagProps = ({ imageUrl }: Coupon) => ({
  enabled: true,
  entity: {
    code: ENTITY_CODE_FREE_INSTALLMENT_RIBBON
  },
  value: {
    src: imageUrl
  }
});

const subtractPercent = (amount: number, percent: number): number =>
  amount - (amount * percent) / 100;

export const isValidCoupon = (coupon: Coupon, paymentMethod: PaymentMethod): boolean => {
  const isValid = coupon && coupon.isValid;

  return (
    isValid &&
    (!coupon.paymentMethods.length ||
      coupon.paymentMethods.some(({ name }) => name === paymentMethod))
  );
};

export type ApplyCouponToOffer = (
  offer?: Offer,
  coupon?: Coupon,
  paymentMethod?: PaymentMethod
) => Offer;

export const applyCouponToOffer: ApplyCouponToOffer = (offer, coupon, paymentMethod) => {
  if (!offer || !isValidCoupon(coupon, paymentMethod)) return offer;

  const { ...mainAttribute } = offer.product.mainAttribute;
  const [...productAttributes] = offer.product.productAttributes;

  switch (coupon.category.code) {
    case PromotionCategoryType.FREE_INSTALLMENTS:
      productAttributes.push(createGiftPA("Cuotas gratis", coupon));
      break;
    case PromotionCategoryType.DISCOUNT:
      const previousTotal = mainAttribute.value.amount;
      const discountPercent = coupon.category.value.percentage as number;
      const amount = subtractPercent(previousTotal, discountPercent);

      if (!discountPercent || !amount) {
        break;
      }

      mainAttribute.value = {
        ...mainAttribute.value,
        amount,
        discountPercent,
        previousTotal
      };

      break;
    case PromotionCategoryType.GIFT:
      productAttributes.push(createGiftPA("Regalo", coupon));
      break;
  }

  if (coupon.imageUrl) {
    productAttributes.push(getFlagProps(coupon));
  }

  return {
    ...offer,
    product: {
      ...offer.product,
      mainAttribute,
      productAttributes
    }
  };
};

export const getCouponByCode = (coupon: string, productId: number): Promise<Coupon> =>
  fetch(`${URL}/${coupon}/format?type=coupon&product=${productId}`)
    .then(response => response.ok && response.json())
    .then(coupon => coupon);
